import { VuexModule, Module, Mutation, getModule, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import api from '@/api'
import store from '.'
import { FiltersTypes } from './filtersTypes'

export interface ITableFiltersState {
    showTableFiltersDialog: boolean;
    sortFiltersDialogTableName: string;
    tableFiltersObj: any;
    tableFiltersObjCopy: any;
}

const originalTableFiltersObj: any = {}
_.cloneDeep(FiltersTypes).forEach(val => {
    const tableFiltersObj = {}
    val.tableFiltersList.forEach((item, key) => {
        const filterName: any = item.filterName
        item.index = key
        delete item.filterName
        tableFiltersObj[filterName] = item
    })
    originalTableFiltersObj[val.tableName] = tableFiltersObj
})

const tableFiltersObj = _.cloneDeep(originalTableFiltersObj)

const tableFiltersObjCopy = _.cloneDeep(originalTableFiltersObj)

/**
 * showTableFiltersDialog 控制顶层dialog显示和隐藏
 *
 * tableFiltersObj 是前端需要自己维护的表格筛选项对象
 *
 * sortFiltersDialogTableName 是具体的表格名字，需注意该名字要与表格ref名保持一致！！！。
 */
@Module({ dynamic: true, namespaced: true, store, name: 'tableFilters' })
class TableFilters extends VuexModule implements ITableFiltersState {
    public showTableFiltersDialog: boolean = false;

    public sortFiltersDialogTableName: string = '';

    public tableFiltersObj: any = tableFiltersObj;

    public originalTableFiltersObj: any = originalTableFiltersObj;

    public tableFiltersObjCopy: any = tableFiltersObjCopy;

    @Mutation
    public CLOSE_SORT_FILTERS_DLG() {
        this.showTableFiltersDialog = false
    }

    @Mutation
    public OPEN_SORT_FILTERS_DLG() {
        this.showTableFiltersDialog = true
        // 打开时进行备份，一直操作备份，点ok更新，cancel按钮只负责关闭弹窗
        this.tableFiltersObjCopy[this.sortFiltersDialogTableName] = _.cloneDeep(this.tableFiltersObj[this.sortFiltersDialogTableName])
    }

    @Mutation
    public SAVE_TABLE_NAME(tableName) {
        this.sortFiltersDialogTableName = tableName
    }

    @Mutation
    public CHANGE_CHECKED_STATUS(payload) {
        const { name, label } = payload
        this.tableFiltersObjCopy[name][label].checked = !this.tableFiltersObjCopy[name][label].checked
    }

    @Mutation
    public RESTORE_DEFAULT_SETTINGS() {
        this.tableFiltersObjCopy[this.sortFiltersDialogTableName] = _.cloneDeep(this.originalTableFiltersObj[this.sortFiltersDialogTableName])
    }

    @Mutation
    public UPDATE_FILTERS_STATE(updatedObj) {
        if (!updatedObj) return
        const newFilters: string[] = []
        const config = this.tableFiltersObj[this.sortFiltersDialogTableName]
        const configKeys = Object.keys(config)
        configKeys.forEach(key => {
            if (updatedObj[key]) {
                config[key].checked = updatedObj[key].checked
                config[key].index = updatedObj[key].index
            } else {
                newFilters.push(key) // 收集新增的筛选项
            }
        })
        newFilters.forEach(item => {
            configKeys.forEach(key => {
                if (!newFilters.includes(key) && config[key].index >= config[item].index) { // 找到所有index大于等于新筛选项的筛选项，将其index+1，保证新筛选项位于其index的位置，且整个table的index不出现重复
                    config[key].index++
                }
            })
        })
    }

    @Mutation
    public DEFAULT_DATA(tableName) {
        this.tableFiltersObj[tableName] = _.cloneDeep(this.originalTableFiltersObj[tableName])
        this.tableFiltersObjCopy[tableName] = _.cloneDeep(this.tableFiltersObj[tableName])
    }

    @Action({ rawError: true })
    public async GET_TABLE_FILTERS_CONFIG(tableName) {
        const res = await api.get_table_filters_config({filterTableName: tableName})
        this.SAVE_TABLE_NAME(tableName)
        if (res.data === 'Default Config Constant') return // 默认配置常量 则无需重新赋值
        this.UPDATE_FILTERS_STATE(JSON.parse(res.data || 'null'))
    }
}

export const TableFiltersModule = getModule(TableFilters)
